<div class="warpper-question">
    <div class="contain">
        <input placeholder="{{'questionBoard.edit.placeholder' | translate}}" class="link"
            [formControl]="questionForm.controls.text" placeholder="{{'questionBoard.edit.address-link'| translate}}">
    </div>
</div>